var map = {
	"./24Hours.vue": 15050,
	"./AddToBasket.vue": 33213,
	"./Approval.vue": 47219,
	"./ArrowDown.vue": 46148,
	"./ArrowLeft.vue": 21234,
	"./ArrowRight.vue": 58649,
	"./ArrowUp.vue": 84743,
	"./Attachment.vue": 87779,
	"./Attention.vue": 37204,
	"./Ban.vue": 6119,
	"./Barcode.vue": 53030,
	"./Basket.vue": 73889,
	"./Bin.vue": 84122,
	"./Bulb.vue": 389,
	"./Calc.vue": 78224,
	"./Calendar.vue": 62435,
	"./Cancel.vue": 99508,
	"./CashRegister.vue": 88501,
	"./ChangePassword.vue": 86729,
	"./Check.vue": 9912,
	"./CheckCorrect.vue": 92748,
	"./CheckIncorrect.vue": 12154,
	"./Chevron.vue": 99134,
	"./Circle.vue": 93352,
	"./CircleGray.vue": 46895,
	"./Clear.vue": 97523,
	"./Close.vue": 17834,
	"./Coin.vue": 72216,
	"./Coins.vue": 41962,
	"./Consents.vue": 65720,
	"./Copy.vue": 59443,
	"./CreditCard.vue": 89836,
	"./DiagnosticsError.vue": 92310,
	"./DiagnosticsOk.vue": 32161,
	"./Doc.vue": 76715,
	"./Documents.vue": 15270,
	"./Download.vue": 52215,
	"./DownloadAttachment.vue": 52727,
	"./Dropdown.vue": 59819,
	"./Drs.vue": 54289,
	"./Edit.vue": 77443,
	"./Envelope.vue": 94315,
	"./ErrorCircle.vue": 93182,
	"./Eye.vue": 17159,
	"./EyeClosed.vue": 58599,
	"./Facebook.vue": 23914,
	"./Filter.vue": 83665,
	"./FractionMix.vue": 17151,
	"./FractionOff.vue": 8579,
	"./FractionOn.vue": 15719,
	"./Heart.vue": 18803,
	"./Help.vue": 86111,
	"./Hours.vue": 37140,
	"./Info.vue": 54265,
	"./Instagram.vue": 20319,
	"./InvalidMark.vue": 4848,
	"./ItemPromotionalDiscount.vue": 72868,
	"./ItemPromotionalFree.vue": 88304,
	"./ItemPromotionalPercentage.vue": 54093,
	"./ItemPromotionalPrice.vue": 20076,
	"./Left.vue": 65949,
	"./Logout.vue": 91021,
	"./Loupe.vue": 22072,
	"./Mail.vue": 29167,
	"./Manage.vue": 24012,
	"./MarkAsUnread.vue": 68464,
	"./MyData.vue": 87726,
	"./NoImg.vue": 77177,
	"./NoPhoto.vue": 25873,
	"./NotificationBell.vue": 44020,
	"./Ok.vue": 30111,
	"./PadlockDown.vue": 34989,
	"./PadlockUp.vue": 33611,
	"./PaperPlane.vue": 48630,
	"./Pdf.vue": 17283,
	"./Phone.vue": 80709,
	"./Plus.vue": 93547,
	"./PriceTags.vue": 33070,
	"./Producenci.vue": 98246,
	"./Promo.vue": 90762,
	"./PromoList.vue": 47993,
	"./Promotions.vue": 75814,
	"./Pulpit.vue": 35101,
	"./Report.vue": 97180,
	"./Right.vue": 18948,
	"./Rozliczenia.vue": 26674,
	"./Save.vue": 73055,
	"./Scale.vue": 16152,
	"./Share.vue": 39742,
	"./Shop.vue": 82403,
	"./SmokingSegment.vue": 80352,
	"./SortDown.vue": 98440,
	"./SortUp.vue": 27837,
	"./Spinner.vue": 2841,
	"./Statystyki.vue": 23305,
	"./Success.vue": 18270,
	"./Sum.vue": 6421,
	"./Upload.vue": 50052,
	"./User.vue": 70517,
	"./UserAvatarMenuHidden.vue": 58819,
	"./UserAvatarMenuOpened.vue": 61609,
	"./UsersManagement.vue": 37633,
	"./Uslugi.vue": 58885,
	"./Warning.vue": 99760,
	"./WarningFull.vue": 10913,
	"./Website.vue": 78970,
	"./Xls.vue": 16009,
	"./Youtube.vue": 64680,
	"./Zip.vue": 48204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33942;